import React from 'react';
import styles from './TaviReportTable.module.scss';

export interface TaviReportRow {
  label: string;
  value?: number | string | null;
  decimals?: number;
  suffix?: string;
}

export interface TaviReportSection {
  title: string;
  rows: TaviReportRow[];
}

export interface TaviReportTableProps {
  sections: TaviReportSection[] | undefined;
}


const formatValue = (row: TaviReportRow): string => {
  const { value, decimals = 1, suffix = '' } = row;
  if (value === null || value === undefined || value === '') return '-';
  if (typeof value === 'number' && Number.isFinite(value)) {
    return `${value.toFixed(decimals)}${suffix}`;
  }
  return `${String(value)}${suffix}`;
};

const TaviReportTable: React.FC<TaviReportTableProps> = ({
  sections,
}) => {
  if (!sections || sections.length === 0) return null;
  return (
    <div className={styles.taviReport}>
      <div className={styles.taviTable}>
        <div className={styles.taviColumns}>
          <div className={styles.tableRow}>
            <div className={`${styles.rowData} ${styles.header}`}>
              <span>Measurement</span>
            </div>
            <div
              className={`${styles.rowData} ${styles.header} ${styles.headerValue}`}
            >
              <span>Value</span>
            </div>
          </div>
          {sections.map((section) => (
            <React.Fragment key={section.title}>
              <div className={styles.dataCells}>
                <span>{section.title}</span>
              </div>
              {section.rows.map((row) => (
                <div
                  className={styles.tableRow}
                  key={`${section.title}-${row.label}`}
                >
                  <div className={`${styles.rowData} ${styles.measurement}`}>
                    <span>{row.label}</span>
                  </div>
                  <div className={`${styles.rowData} ${styles.value}`}>
                    <span>{formatValue(row)}</span>
                  </div>
                </div>
              ))}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TaviReportTable;
